module.exports = __webpack_public_path__ + "img/male_asset.77ced3c9.png";